import React from "react";
import { Container, TextField, Card, CardContent, Typography, Box, InputAdornment, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useFetch from "../utils/UseFetch";
import { useNavigate } from "react-router-dom";
import { token, prequalificationheader } from "../HelperFx/datalinks";
import Swal from 'sweetalert2';
import axios from "axios";

// import { token, prequalificationLines, prequalificationheader } from "../HelperFx/datalinks";

const eq = ' eq ';
const filter = '?$filter =';
const R_COMPANY = process.env.REACT_APP_COMPANY;
const B_URL = process.env.REACT_APP_BIDDING_API_DATA_URL

const Prequalifications = () => {
  const vendorNo = sessionStorage.getItem('vendorNo');
  const navigate = useNavigate();
  // `${prequalificationheader}&${filter}vendorNo${eq}'${vendorNo}'`, 
  const { data: itemsLines, loading, error } = useFetch(
    `${prequalificationheader}&$filter=relatedpartyNo${eq}'${vendorNo}'`, 
    token
  );

  const CreatePrequalification = async () => {
    const preqDetails = { no: vendorNo };

    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You want to create a prequalification",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Create it!",
      });

      if (!result.isConfirmed) return;

      // Create Prequalification using Axios
      const { data } = await axios.post(
        `${B_URL}CreatePrequalification?${R_COMPANY}`,
        preqDetails,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Error creating Prequalification: ${data.error.message}`,
        });
        console.error("Error creating Prequalification:", data.error);
        return;
      }

      console.log("Prequalification created successfully:", data.value);

      if (data.value) {
        // Navigate directly using the returned PreqNo
        navigate(`/prequalification`, { state: { PreqNo: data.value } });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Prequalification number not returned from API.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Error creating Prequalification: ${error.message}`,
      });
      console.error("Error creating Prequalification:", error);
    }
  };


  // Process the data to create Bids array in reverse order
  const Prequalifications = React.useMemo(() => {
    if (!itemsLines?.value) return [];
    
    return itemsLines.value
      .reverse(); // Reverse the array to show newest first
  }, [itemsLines]);

  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredPrequalifiquations = Prequalifications.filter(preqn =>
    preqn.no.toLowerCase().includes(searchTerm.toLowerCase()) ||
    preqn.description.toLowerCase().includes(searchTerm.toLowerCase())||
    preqn.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4, ml: 0 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search bids..."
          sx={{ mr: 2 }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          onClick={CreatePrequalification}
          sx={{ whiteSpace: "nowrap",backgroundColor: "#5C2626",px: 3, py: 1.5,} } >
          New Prequalification
        </Button>
      </Box>
      {loading && <Typography>Loading Prequalifications...</Typography>}
      {error && <Typography color="error">Error loading Prequalifications: {error.message}</Typography>}
      
      {filteredPrequalifiquations.length === 0 && !loading && (
        <Typography>No Prequalification found for your vendor account.</Typography>
      )}

      {filteredPrequalifiquations.map((prequaln, index) => (
        <Card key={index} sx={{ mb: 2, width: "100%", height: "100px" }}>
          <CardContent>
            <Typography variant="h6" color="primary" sx={{ fontSize: 15 }}>
              <a style={{ cursor: "pointer" }} onClick={() => navigate(`/prequalification`, {state: {PreqNo: prequaln.no}})}>
                {prequaln.no}
              </a>
            </Typography>
            <Typography variant="body1" sx={{ mt: 0 }}>
              {prequaln.description}
            </Typography>
            <Box sx={{ mt: 1, fontStyle: "italic", color: "gray" }}>
              Status: {prequaln.status}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default Prequalifications;